// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"edc16d39","453":"2dc039d0"}[chunkId] + ".chunk.js";
};